/* 布局 */
//前台
import Layout from "@views/layout";

const sysarticleRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "sysarticle",
            name: "SYSARTICLE",
            meta: {
                title: "系统文章管理",
                sort: 1,
            },
            component: () => import("@views/business/sysarticle/index.vue"),
            redirect: {
                name: "SYSARTICLE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "SYSARTICLE_LIST",
                    meta: {
                        title: "系统文章管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/sysarticle/list.vue"),
                },
                                {
                    path: "add",
                    name: "SYSARTICLE_ADD",
                    meta: {
                        title: "新增系统文章",
                        parentPath: '/business/sysarticle/list',
                        operate: true,
                    },
                    component: () => import("@views/business/sysarticle/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "SYSARTICLE_EDIT",
                    meta: {
                        title: "编辑系统文章",
                        parentPath: '/business/sysarticle/list',
                        operate: true,
                    },
                    component: () => import("@views/business/sysarticle/form.vue"),
                },
                                        ],
    },


        ],
};

export default sysarticleRouter;
